<template>
    <v-dialog v-model="productsBulkPriceEditModal" max-width="1000" class="price-modal">
        <v-card>
            <v-card-title class="headline">{{ "Add new price to products" | t }}</v-card-title>
            <v-card-subtitle class="subtitle-1 mb-0 pb-0"
                >{{ "Select which date and price should attach to following products" | t }}
            </v-card-subtitle>
            <v-card-text class="price-modal-container">
                <v-row>
                    <v-col class="d-flex justify-center">
                        <v-date-picker
                            v-model="selectedDate"
                            mode="date"
                            :model-config="modelConfig"
                            is-required
                            :attributes="attrs"
                        />
                    </v-col>
                    <v-col class="d-flex align-center"
                        ><v-select
                            v-model="selectedType"
                            :items="typeItems"
                            :item-text="item => t(item.title)"
                            item-value="id"
                            class="mt-3 mb-3"
                            dense
                            hide-details
                            :label="t('Price type')"
                            outlined
                        ></v-select
                    ></v-col>
                    <v-col class="d-flex align-center">
                        <v-text-field
                            v-model="selectedValue"
                            type="number"
                            step="0.1"
                            class="mt-3 mb-3"
                            dense
                            hide-details
                            :label="t('Value')"
                            outlined
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="bal-dark-gray" text @click="toggleProductsBulkPriceEditModal">
                    {{ "Close" | t }}
                </v-btn>

                <v-btn
                    color="bal-green"
                    :disabled="exportProducts.length <= 0 || !selectedType || !selectedDate || !selectedValue"
                    text
                    @click="handleAddClick"
                >
                    {{ "Add" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { userTranslationFunctions } from "../../mixins/user-translation-functions";
import moment from "moment/moment";
import VCalendar from "v-calendar";

export default {
    name: "products-bulk-price-edit-modal",
    mixins: [userTranslationFunctions],
    components: { VCalendar },
    computed: {
        ...mapState("ProductStore", ["productsBulkPriceEditModal", "exportProducts"])
    },
    data() {
        return {
            selectedDate: null,
            selectedType: null,
            selectedValue: 0,
            typeItems: [
                {
                    id: "list_net_price",
                    title: "Price list price"
                },
                {
                    id: "cost_price",
                    title: "Cost price"
                },
                {
                    id: "export_price",
                    title: "Export price"
                },
                {
                    id: "own_price",
                    title: "Own price"
                }
            ],
            modelConfig: {
                type: "string",
                mask: "YYYY-MM-DD" // Uses 'iso' if missing
            },
            attrs: [
                {
                    key: "today",
                    highlight: true,
                    dates: new Date(),
                    content: "red"
                }
            ]
        };
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        ...mapMutations("ProductStore", [
            "toggleProductsBulkPriceEditModal",
            "resetExportProducts",
            "togglePriceMode",
            "setRequestSuccess",
            "setRequestError",
            "setErrorMessage"
        ]),
        ...mapActions("ProductStore", ["saveBulkProductPrices"]),
        async handleAddClick() {
            let payload = {
                date: this.selectedDate,
                type: this.selectedType,
                products: this.exportProducts.map(p => p.id).join(","),
                value: this.selectedValue
            };

            const response = await this.saveBulkProductPrices(payload);

            if (response) {
                this.setRequestSuccess(true);
                this.selectedDate = null;
                this.selectedType = null;
                this.selectedValue = 0;
                this.toggleProductsBulkPriceEditModal();
                this.togglePriceMode();
            } else {
                this.setErrorMessage(this.t("Failed"));
                this.setRequestError(true);
            }
        },
        getDate(value) {
            if (value) return moment(value).format("DD.MM.YYYY");
            else return null;
        }
    }
};
</script>

<style scoped>
.price-modal-container,
.price-modal {
    height: 100%;
    max-height: 600px !important;
    min-height: 300px;
}
.price-modal-container {
    overflow: auto;
}
</style>
